
import { types, actions } from './requests'
export const DELETEMAPPING_TYPES = {
    ...types('DELETEMAPPING'),
}
export const DELETEMAPPING_ACTIONS = {
    ...actions('DELETEMAPPING'),
}